/**
 * Ensure product card images are clickable
 * This script ensures that clicks on product images navigate to the product page
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all product card media links
  const mediaLinks = document.querySelectorAll('.card__media-link');

  mediaLinks.forEach(link => {
    // Ensure the link is clickable by stopping event propagation from being blocked
    link.addEventListener('click', function(e) {
      // Don't prevent default - let the link work normally
      // Stop propagation to prevent parent elements from interfering
      e.stopPropagation();
    }, true); // Use capture phase to run before other handlers

    // Make sure pointer events work
    link.style.pointerEvents = 'auto';
    link.style.cursor = 'pointer';
  });

  // Also handle any product-card-slider elements
  const sliders = document.querySelectorAll('product-card-slider');
  sliders.forEach(slider => {
    slider.style.pointerEvents = 'none';

    // Find the link inside and ensure it's clickable
    const link = slider.querySelector('.card__media-link');
    if (link) {
      link.style.pointerEvents = 'auto';
      link.style.cursor = 'pointer';
    }
  });
});
